//const axios = require('axios').default;
import {prepareRequest} from "../../index.js";
import {setParamsToURL} from "../../index.js"
import store from '../../../state/store';
import {PROJECT_API_URL_LIST} from "@/services/routes/project";

async function getProjects(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(PROJECT_API_URL_LIST.LIST_PROJECT_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function getProjectsBySearch(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_LIST_BY_SEARCH_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function getSingleProject(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_SINGLE, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function getSingleProjectByCode(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_SINGLE_BY_PCODE, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}


async function addProject(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_ADD_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function updateProject(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_UPDATE_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function deleteProject(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_DELETE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function approveProject(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_APPROVE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function updateProjectCode(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(PROJECT_API_URL_LIST.PROJECT_UPDATE_CODE, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}


export {getProjects, addProject, updateProject, deleteProject, getSingleProject, getProjectsBySearch, approveProject, updateProjectCode,getSingleProjectByCode};